import { ConstraintFacilityExpansionBase } from './base/constraint-facility-expansion-base';

export class ConstraintFacilityExpansion extends ConstraintFacilityExpansionBase { }